import { Component, Input } from '@angular/core';
import { SummaryItem } from '../../../models';

@Component({
  selector: 'app-report-value-pairs',
  templateUrl: './report-value-pairs.component.html',
  styleUrl: './report-value-pairs.component.scss',
})
export class ReportValuePairsComponent {
  @Input() summaryItems: SummaryItem[];
  @Input() cssClass?: string;
  @Input() labelMinWidth = true;
}
